import React, { useState, useEffect } from 'react';

const HeaderDXReloj = ({ startTime, estadoDx = null }) => {
  const [elapsed, setElapsed] = useState(0);

  // ocultar sólo cuando estadoDx indica finalizado (8). Si estadoDx es undefined/null mostramos el reloj.
  const hideTimer = estadoDx === '8' || estadoDx === 8;
  const showTimer = !hideTimer;

  useEffect(() => {
    let intervalId = null;

    if (!showTimer) {
      setElapsed(0);
      return () => clearInterval(intervalId);
    }

    const baseTime = startTime ? new Date(startTime) : new Date();
    const getElapsed = () => Math.floor((Date.now() - baseTime.getTime()) / 1000);

    setElapsed(getElapsed());
    intervalId = setInterval(() => setElapsed(getElapsed()), 1000);

    return () => clearInterval(intervalId);
  }, [startTime, showTimer]);

  const pad = n => n.toString().padStart(2, '0');
  const hours = pad(Math.floor(elapsed / 3600));
  const minutes = pad(Math.floor((elapsed % 3600) / 60));
  const seconds = pad(elapsed % 60);

  return (
    <div className='card'>
      <div className="card-header">
        <div className='row'>
          <div className="col-md-4 col-sm-4">
            <h3 className="card-title">
              <b>Formulario Diagnostico Base</b>
              <p>Llenar todos los campos para el declarante.</p>
            </h3>
          </div>
          <div className="col-md-4 col-sm-4">
            {showTimer && (
              <div id="contenedor">
                <div className="reloj" id="Horas">{hours}</div>
                <div className="reloj" id="Minutos">:{minutes}</div>
                <div className="reloj" id="Segundos">:{seconds}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderDXReloj;